<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Forgot Password | Homabay County HR System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Reset your password" name="description" />
      <meta content="" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body class="auth-body-bg">
    <div>
      <div class="container-fluid p-0">
        <div class="row g-0">
          <div class="col-xl-8 col-lg-8">
            <div class="pt-lg-5 p-4 bg-overlay" :style="backgroundStyle">
              <div class="w-100">
                <div class="bg-overlay"></div>
                <div class="d-flex h-100 flex-column">
                  <div class="p-4 mt-auto">
                    <div class="row justify-content-center">
                      <div class="col-lg-7">
                        <div class="text-center">
                          <img :src="county_logo()" alt="Logo" class="img mb-3" style="width: 170px;">
                          <h4 class="mb-0 text-white">
                            <i class="bx bxs-quote-alt-left text-success h1 align-middle me-3"></i>
                            <span>Right there for you</span>
                          </h4>
                          <p class="font-size-16 text-white mb-0">Homabay County HR System</p>
                          <strong>-</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-xl-4 col-md-4">
            <div class="auth-full-page-content p-md-5 p-4">
              <div class="w-100">
                <div class="d-flex flex-column h-100">
                  <div class="mb-4 mb-md-5">
                    <a href="javascript:void(0);" @click="goToLogin" class="d-block auth-logo">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-dark">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-light">
                    </a>
                  </div>

                  <div class="my-auto">
                    <!-- Step 1: Request Reset -->
                    <div v-if="currentStep === 'request'">
                      <div class="text-center mb-4">
                        <div class="avatar-md mx-auto">
                          <div class="avatar-title bg-primary bg-gradient rounded-circle text-white">
                            <i class="bx bx-lock-open font-size-24"></i>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h5 class="text-primary text-center">Forgot Password?</h5>
                        <p class="text-muted text-center">Enter your email or ID number and we'll send you a temporary password</p>
                      </div>

                      <div class="mt-4">
                        <div class="mb-3">
                          <label for="identifier" class="form-label">Email Address or ID Number</label>
                          <div class="input-group">
                            <span class="input-group-text">
                              <i class="mdi mdi-account"></i>
                            </span>
                            <input
                                v-model="identifier"
                                type="text"
                                class="form-control"
                                id="identifier"
                                placeholder="Enter your email or ID number"
                                @keyup.enter="requestReset"
                                :disabled="isLoading"
                            >
                          </div>
                        </div>

                        <!-- Alert Messages -->
                        <div v-if="alert.success" class="alert alert-success" role="alert">
                          <i class="mdi mdi-check-circle me-2"></i>{{ message }}
                        </div>

                        <div v-if="alert.info" class="alert alert-primary" role="alert">
                          <i class="mdi mdi-information me-2"></i>{{ message }}
                        </div>

                        <div v-if="alert.failed" class="alert alert-danger" role="alert">
                          <i class="mdi mdi-alert-circle me-2"></i>{{ message }}
                        </div>

                        <div class="mt-3 d-grid">
                          <button
                              @click="requestReset"
                              class="btn btn-primary waves-effect waves-light"
                              type="button"
                              :disabled="isLoading || !identifier"
                          >
                            <span v-if="!isLoading">
                              <i class="mdi mdi-email-send me-1"></i>Send Reset Email
                            </span>
                            <span v-else>
                              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                              Sending...
                            </span>
                          </button>
                        </div>

                        <div class="mt-4 text-center">
                          <a href="javascript:void(0);" @click="goToLogin" class="text-muted">
                            <i class="mdi mdi-arrow-left me-1"></i> Back to Login
                          </a>
                        </div>
                      </div>
                    </div>

                    <!-- Step 2: Success Message -->
                    <div v-if="currentStep === 'success'">
                      <div class="text-center mb-4">
                        <div class="avatar-md mx-auto">
                          <div class="avatar-title bg-success bg-gradient rounded-circle text-white">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h5 class="text-success text-center">Email Sent Successfully!</h5>
                        <p class="text-muted text-center">We've sent a temporary password to your email address.</p>
                      </div>

                      <div class="alert alert-info border-0 mt-4" role="alert">
                        <div class="d-flex">
                          <div class="flex-shrink-0">
                            <i class="mdi mdi-information-outline me-2 font-size-18"></i>
                          </div>
                          <div class="flex-grow-1">
                            <strong>Next Steps:</strong>
                            <ul class="mb-0 mt-2">
                              <li>Check your email inbox</li>
                              <li>Use the temporary password to login</li>
                              <li>Change your password after logging in</li>
                              <li>Check spam folder if you don't see the email</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="mt-4 d-grid">
                        <button
                            @click="goToLogin"
                            class="btn btn-primary waves-effect waves-light"
                            type="button"
                        >
                          <i class="mdi mdi-login me-1"></i>Go to Login
                        </button>
                      </div>

                      <div class="mt-3 text-center">
                        <a href="javascript:void(0);" @click="resendEmail" class="text-muted">
                          <i class="mdi mdi-email-sync me-1"></i> Didn't receive email? Resend
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 mt-md-5 text-center">
                    <p class="mb-0">© {{ currentYear }} <strong>Homabay County HR System</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    </body>
  </div>
</template>

<script>
import { authUrl, county_logo, login_bg, execute } from "@/api";
import router from "@/router";

export default {
  name: "ForgotPassword",
  data() {
    return {
      backgroundUrl: login_bg,
      identifier: '',
      isLoading: false,
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      currentStep: 'request', // 'request' or 'success'
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    },
  },
  methods: {
    county_logo() {
      return county_logo;
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    goToLogin() {
      router.push('/');
    },

    async requestReset() {
      // Validate input
      if (!this.identifier || this.identifier.trim() === '') {
        this.clearAlerts();
        this.message = "Please enter your email or ID number";
        this.alert.failed = true;
        return;
      }

      this.clearAlerts();
      this.message = "Sending reset email...";
      this.alert.info = true;
      this.isLoading = true;

      const data = new FormData();
      data.append("function", "forgotPassword");
      data.append("identifier", this.identifier.trim());

      try {
        const res = await execute(data, authUrl);

        this.clearAlerts();
        this.isLoading = false;

        if (res.data.success) {
          // Success - move to success step
          this.currentStep = 'success';
          this.message = res.data.message || "Password reset email sent successfully!";
        } else {
          // Failed
          this.alert.failed = true;
          this.message = res.data.message || "Failed to send reset email. Please try again.";
        }
      } catch (error) {
        this.clearAlerts();
        this.isLoading = false;
        this.alert.failed = true;
        this.message = error.message || "An error occurred. Please try again.";
        console.error("Forgot password error:", error);
      }
    },

    async resendEmail() {
      // Simply call requestReset again
      this.currentStep = 'request';
      this.clearAlerts();
      await this.requestReset();
    }
  }
}
</script>

<style scoped>
.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex;
  height: 100vh;
}

.bg-overlay {
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
}

.auth-full-page-content {
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.avatar-md {
  height: 4rem;
  width: 4rem;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* Loading spinner animation */
.bx-spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.input-group-text {
  background-color: #f8f9fa;
}

.alert {
  border-radius: 0.5rem;
}
</style>